export default __webpack_public_path__ + "assets/images/2062d1747827ee4945775a846f29675c.jpg";